<script lang="ts" setup>
  import CURadioButton from '@/components/CURadioButton.vue'
  import {URMRole, URMRoleKey,} from '@/models/dto/userRoleManagement'

  const props = withDefaults(defineProps<{
    modelValue: URMRoleKey
    userRoles: URMRole[]
    disabledUserRoles?: URMRole[]
    message?: string
  }>(), {
    disabledUserRoles: () => []
  })

  const emit = defineEmits<{
    (e: 'update:model-value', value: string): void
  }>()

  const selectUserRole = (userRole: URMRole) => {
    if (isDisabled(userRole.key)) {
      return
    }
    emit('update:model-value', userRole.key)
  }

  const isDisabled = (roleKey: string) => {
    return props.disabledUserRoles.some(role => role.key === roleKey)
  }

  const isSelected = (roleKey: string) => {
    return props.modelValue === roleKey
  }
</script>

<template>
  <div>
    <label class="font-12">{{ $t('tripContact.SELECT_USER_TYPE') }}</label>
    <div
      v-for="(role, roleIndex) in userRoles"
      :id="`user-role-${role.key}`"
      :key="`user-role-${role.key}-${roleIndex}`"
      class="d-flex flex-row border-radius-4 border-2 border-solid padding-x-3 padding-y-2 margin-b-2"
      :class="{
        'cursor-pointer': !isDisabled(role.key),
        'background-gray-lighter': isDisabled(role.key),
        'border-midnight-gray-50': !isSelected(role.key),
        'border-primary background-blue-10': isSelected(role.key),
      }"
      @click="selectUserRole(role)"
    >
      <div class="d-flex flex-column">
        <h4
          :id="`user-role-label-${role.key}`"
          class="font-14 font-bold margin-b-1"
          :class="{ 'text-gray-light': isDisabled(role.key) }"
        >
          {{ role.label }}
        </h4>
        <p
          :id="`user-role-description-${role.key}`"
          class="font-14 margin-t-0"
          :class="{ 'text-gray-light': isDisabled(role.key) }"
        >{{ role.description }}</p>
      </div>
      <div class="d-flex flex-column justify-center margin-l-3">
        <CURadioButton
          :id="`user-role-radio-${role.key}`"
          large
          :selected="isSelected(role.key)"
        />
      </div>
    </div>
    <p
      v-if="message"
      id="user-role-message"
      class="font-12 text-center margin-t-1 text-gray-light"
      :style="{ 'font-style': 'italic' }"
    >
      {{ message }}
    </p>
  </div>
</template>
